import { Base64 } from 'js-base64';
import {html, css, LitElement} from 'lit';
import { StorageMixin } from '../storage-mixin.js'

export class DzFacetedFilter extends StorageMixin(LitElement) {

    static properties = {    
        filter:  {type: String, store: true },
        store:   {type: String, store: true },
        noquery: {type: Boolean },
    };

    constructor() {
        super()
        this.noquery = false
        this.order = []
    }

    connectedCallback() {
        super.connectedCallback()

        this.addEventListener("select", evt => {
            if (!evt.initial) {
                if(this.order.length === 0 && this.filter.prop && Object.keys(this.filter.prop).length > 0) {
                    this.order = Object.keys(this.filter.prop);
                }
                let group = evt.source.closest("dz-property-spoiler").name
                if (!this.order.includes(group)) {
                    this.order.push(group)
                }
                this.applyFacets()
            }
        })

        this.addEventListener("deselect", evt => {
            if (!evt.initial) {
                let group = evt.source.closest("dz-property-spoiler").name
                if (evt.lastDeselect && this.order.includes(group)) {
                    this.order = this.order.filter(g => g != group)
                }
                this.applyFacets()
            }
        })
    }

    render() {
        let items = []

        for (let [name, data] of Object.entries(this.store)) {
            let opened = this.filter && this.filter["prop"] && name in this.filter["prop"]
            let list_view = ""
            
            let values = []
            for (let [val, cnt] of Object.entries(data["values"])) {
                let selected = this.filter && this.filter["prop"] && this.filter["prop"][name] ? this.filter["prop"][name].includes(val) : false
                values.push(html`
                    <dz-selectable detail="${val}" searchitem="filter-value" class="value-selector" ?selected="${selected}" ?disabled="${cnt <= 0}">
                        <div searchtext="filter-value">${val}</div>
                    </dz-selectable>  
                `)
            }
            
            if (Object.keys(data["values"]).length > 8) {
                list_view = html`
                    <dz-compact-search searchclass="filter-value" collapsed>
                        <dz-search-field slot="panel" placeholder="Поиск по значениям"></dz-search-field>
                            ${values}    
                    </dz-compact-search>
                `
            
            } else {
                list_view = html`${values}`
            }


            items.push(html`
                <dz-property-spoiler name="${name}" searchitem="property-spoiler" class="filter-spoiler" data-filter="${name}" @apply="${this.applyFilters}" ?opened="${opened}">
                    <span searchtext="property-spoiler">${name}</span>
                    <dz-multi-select slot="body" class="selection">
                        ${list_view}
                    </dz-multi-select>
                </dz-property-spoiler>   
            `)        
        }

        return html`
            <div class="title" style="margin-top: 20px">
		        <span>Фильтры</span>
		        <button part="button" onclick="resetFilters('prop')" class="filter-reset-button">
                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 0V1H0V3H1V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V3H16V1H11V0H5ZM3 3H13V16H3V3ZM5 5V14H7V5H5ZM9 5V14H11V5H9Z" fill="black"/>
                    </svg>
		        </button>
	        </div>
            
                <dz-search-list searchclass="property-spoiler" class="filter-list" id="filter-view">
                    <dz-search-field slot="panel" class="main-search-field" placeholder="Поиск по фильтрам"></dz-search-field>
                    ${items}
                </dz-search-list>
        `
    }


    applyFacets() {
        if (this.filter["section"]) {
            let new_filter = this.filter ? structuredClone(this.filter) : {}
            
            new_filter["prop"] = {}
            this.collectProperties(new_filter)
            
            if (Object.keys(new_filter["prop"]).length > 0) {
                BX.ajax.runAction('dz:content.api.search.getFacets', {
                    data: {
                        sections: new_filter["section"],
                        filter:   new_filter["prop"],
                        properties: Object.keys(this.store) 
                    }  
                }).then((resp) => {
                    let facets = resp.data
                        for (let ps of this.renderRoot.querySelectorAll("dz-property-spoiler")) {
                            for (let ds of ps.querySelectorAll("dz-selectable")) {
                                if (Object.keys(facets[ps.name]).includes(ds.detail)) {
                                    ds.disabled = false
                                } else {
                                    ds.disabled = true
                                }
                            }
                        }   
                }).catch(err => {
                    console.log(err)
                })
            } else {
                for (let ds of this.renderRoot.querySelectorAll("dz-selectable")) {
                    ds.disabled = false
                }
            }
        }
    }

    passFilter(new_filter) {
        if (this.noquery) {
            window.location.href = `.?filter=${encodeURIComponent(Base64.encode(JSON.stringify(new_filter)))}`
        } else {
            let params = new URLSearchParams(window.location.search)
            window.location.href = `.?q=${params.get("q")}&filter=${encodeURIComponent(Base64.encode(JSON.stringify(new_filter)))}`
        }
    }

    collectProperties(new_filter) {
        let fl = this.renderRoot.querySelector(".filter-list")
        for (let group of this.order) {
            let spoiler = this.renderRoot.querySelector(`.filter-spoiler[name="${group}"]`)
            let vs = spoiler.querySelector(".selection")
            if (vs.selected.length) {
                new_filter["prop"][spoiler.dataset.filter] = vs.selected.map(s => s.detail)
            } else {
                if (new_filter["prop"]) {
                    delete new_filter["prop"][spoiler.dataset.filter]          
                }
            }
        }
    }


    applyFilters() {    
        let new_filter = this.filter ? structuredClone(this.filter) : {}
        
        new_filter["prop"] = {}
        this.collectProperties(new_filter)

        if (Object.values(new_filter["prop"]).length == 0) {
            delete new_filter["prop"]
        }
        this.passFilter(new_filter)
    }



    static get styles() {
        return css`
            .filter-list {
                font-family: "Roboto";
                display: block;
                margin-right: 20px;
                margin-top: 20px;
                border-radius: 10px;
                background: rgba(0, 0, 0, 0.025);
                padding-top: 2px;
            }


            .title {
                font-family: "Exo2";
                display: block;
                font-size: 22px;
                position: relative;
            }

            .filter-reset-button {
                appearance: none;
                border: none;
                background: none;
                opacity: 0.3;
                position: absolute;
                right: 20px;
                top: 7px;
            }
              
            .filter-reset-button:hover {
                opacity: 1;
                cursor: pointer;
            }

            .main-search-field {
                margin: 10px;
                margin-top: 20px;
            }

            dz-search-field {
                display: block;
                position: relative;
                margin-bottom: 10px;
            }
              
            dz-search-field::part(reset) {
                position: absolute;
                right: 7px;
                top: 7px;
            }
              
            dz-search-field::part(input) {
                width: 100%;
                height: 30px;
                border-radius: 5px;
                border: solid #0003 1px;
                padding: 0px 10px;
                box-sizing: border-box;
            }

            .filter-spoiler *[slot=head] {
                display: grid;
                position: relative;
                grid-template-columns: 10px 1fr 20px 20px;
                gap: 10px;
                align-items: center;
                padding: 10px;
                border-bottom: solid rgba(0, 0, 0, 0.05) 1px;
                margin-right: 5px;
            }
              
            .filter-spoiler[opened] *[slot=head] {
                font-family: "Roboto Medium";
                color: black;
                border-bottom: none;
            }
              
            .filter-spoiler *[slot=body] {
                display: flex;
                flex-direction: column;
                gap: 5px;  
                border-bottom: none;
                padding: 10px
            }
              
            .filter-spoiler[opened] *[slot=body] {
                border-bottom: solid rgba(0, 0, 0, 0.05) 1px;
                padding-bottom: 20px;
            }
              
            .filter-spoiler .compact-view {
                display: flex;
                gap: 5px;
                flex-direction: column;
                padding: 10px 0px;
            }
              
            .filter-spoiler .value-selector {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 0px px;
            }
              
            .filter-spoiler .value-selector::before {
                content: "";
                display: inline-flex;
                width: 10px;
                height: 10px;
                background: white;
                outline: solid #0003 1px;
                border-radius: 3px;
            }
              
            .filter-spoiler .value-selector[selected]::before {
                background: grey;
                outline-color: white;
                outline-offset: -2px;
            }
              
            .filter-spoiler *[slot=head] > *:first-child {
                font-size:20px;
                line-height: 13px;
                display: flex;
                align-items: center;
                transform-origin: center;
                justify-content: center;
                transition: 0.2s;
                color: #0009;
            }
              
            .filter-spoiler[opened] *[slot=head] > *:first-child {
                transform: rotate(90deg);
            }
              
            .filter-spoiler dz-search-list::part(found) {
                display: block;
                height: 300px;
                overflow-y: auto;
                overflow-x: auto;
                scrollbar-width: thin;  
                scrollbar-color: #0001 #0001;
                padding-left: 3px;
            }
              
            .filter-spoiler dz-multi-select .selector-reset-button {
                display: none;
            }
              
            .filter-spoiler dz-multi-select[choosed] .selector-reset-button {
                display: block;
            }
              
            .filter-spoiler .selector-btn {
                appearance: none;
                border: solid #0001 1px;
                width: 100%;
                border-radius: 5px;
                box-sizing: border-box;
            }

            .spoiler-btn {
                apperance: none;
                border: none;
                background: none;
            }
        `
    }
}

customElements.define('dz-faceted-filter', DzFacetedFilter)